import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { UiAdminModule } from '@eiq/ui';

import { LevelIcon } from '../models/levels.enum';
import { Notification } from '../models/notification.model';

@Component({
  standalone: true,
  selector: 'eiq-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  imports: [CommonModule, FontAwesomeModule, MatSnackBarModule, UiAdminModule]
})
export class NotificationComponent {
  data = inject<Notification>(MAT_SNACK_BAR_DATA);
  levelIcon = LevelIcon;

  private snackBarRef = inject(MatSnackBarRef);

  onDismiss(): void {
    this.snackBarRef.dismiss();
  }

  onDismissWithAction(): void {
    this.snackBarRef.dismissWithAction();
  }
}
